export function invert (data) {
  return Object.keys(data).reduce(function (obj, key) {
    obj[ data[key] ] = key
    return obj
  }, {})
}

export function generateRGBAStr (r, g, b, transparency) {
  return `rgba(${r},${g},${b},${transparency})`
}

export function extractRGBfromStr (strRGB) {
  let values = /rgb\((.*?),(.*?),(.*?)\)+/g.exec(strRGB)
  return values.slice(1).map((v) => { return v.trim() })
}

export function generateStyleString (cssValues) {
  return Object.keys(cssValues).map((key) => { return [key, cssValues[key]].join(': ') }).join(';')
}



// WEBPACK FOOTER //
// ./src/utils.js